export { default } from './DynamicBG';
